'use client'

import { useRouter } from 'next/navigation'

import { UserType } from '@/entities/user'
import { Button, Icon } from '@/shared/ui'

type Props = {
  userType: UserType
  title: string
  createdAt: string
}

export const Header = ({ userType, title, createdAt }: Props) => {
  const router = useRouter()

  const handleBackButtonClick = () => {
    router.push(`/${userType}/notice`)
  }

  return (
    <div className="space-y-2 pb-5">
      <div className="flex items-center justify-between">
        <h2 className="typo-title3 font-semibold text-black">{title}</h2>
        <Button
          variant="outline"
          size="small"
          className="gap-0"
          onClick={handleBackButtonClick}
        >
          <Icon name="arrow-left" size={16} />
          목록으로 돌아가기
        </Button>
      </div>
      <p className="typo-label1 font-normal text-gray-500">{createdAt}</p>
    </div>
  )
}
